import programMixin from '@/mixins/programMixin.js';

function getInitialDocument() {
	return {
		id:null,
		person_id: null,
		file_id: null,
		cat_document_type_id: null,
		cat_file: null,
		isActive: 1
	}
};


function getInitialDataHome() {
	return {
		id: null,
		streetName: null,
		streetNumber: null,
		interiorStreetNumber: null,
		neighborhood: null,
		neighborhood_id: null,
		postalCode: null,
		postal_code_id: null,
		geo_locality_id: null,
		department_id: null,

		geo_cat_country_id: null,
		geo_cat_state_id: null
	}
};

function getInitialDataPhone() {
	return {
		id: null,
		areaCode: null,
		phone: null,
		extension: null,
		used_type_id: null,
		note: null

	}
};


function getInitialDataPeople() { /////////////
	return {
		isCompleted: false,
		id: null,
		hash_id: null,
		dui: null,
		hasFarmRegistry: false,
		farmRegistry: null,
		name: null,
		secondName:null,
		thirdName:null,
		surName: null,
		secondSurName: null,
		thirdSurName:null,
		birthDate: null,
		age: null,
		cat_person_gender_id: null,
		nationality_id: null,
		isPersonWithDisability: false,
		knowReadWrite: false,

		cat_person_marital_status_id: null,
		numberChildren: 0,
		highest_studies_id: null,
		highest_studies_status_id: null,
		job_id: null,
		monthlyIncome: false,
		amountMonthlyIncome: 0,
		amount_monthly_income_currency_id: null,
		isHouseHold: false,
		isOtherHouseHold: false,
		amount_other_house_hold_id: null,
		supportAnyIncomeYourHome: false,


		otherJob: null,
		birth_state_id: null,
		birth_country_id: null,
		birth_locality_id: null,

		haveYouMigratedFromYourCountry: false,
		considerLeavingYourCountry: false,

		didYouArriveAtTheDestinationCountry: false,
		instance_country_id: null,
		numberOfTimesYouHaveLeftTheCountry: null,

		averageTimeOutsideYourCountryYear: null,
		averageTimeOutsideYourCountryMonth: null,
		averageTimeOutsideYourCountryDay: null,

		emigrateAloneOrAccompaniedByRelatives: null,
		doYouHaveRelativesResidingInAnotherCountry: false,
		haveYouWorkedInAnotherCountry: false,
		disabilities_ids: [],
		destination_country_ids: [],
		relatives_country_ids: [],//other table
		worked_another_country_ids: [],//other table

		contact_email: {
			email: null
		},
		contact_phones: [
			{
				...getInitialDataPhone(),
				used_type_id: 1
			},
			{
				...getInitialDataPhone(),
				used_type_id: 2
			},
			{
				...getInitialDataPhone(),
				used_type_id: 3
			},


		],
		contact_homes: [
			getInitialDataHome(),

		],
		family_members: [],
		documents:  [],
		location: {
			id: null,
	        lat:programMixin.methods.isSalvadorProgram() ? 13.446412 : (programMixin.methods.isHondurasProgram() ? 14.8871593 : 0),
			lng: programMixin.methods.isSalvadorProgram() ? -88.528153 :  (programMixin.methods.isHondurasProgram() ? -87.3898346 : 0)
		},
		alias_areas_of_interest: {},
		interest_many:[],
		last_selected_advisor_id: null,
		my_bank_account: null

	}
};

// Initial Object in function
function getGlobal() {
	return {
		id: null,
		a_fellow: {
			person: {
				...getInitialDataPeople(),
			},
		},
		last_log: {
			status_id: 1
		},
	}
};

function arrayCatalogs() {
	return {
		countries: [],
		states: [],
		programs: [],
		gender: [],
		jobs: [],
		personDisabilities: [],
		civilStatus: [],
		hightestStudies: [],
		hightestStudiesStatuses: [],
		departments: [],
		localities: [],
		countriesPrograms: [],
		currencies: [],
		catTypeDocuments: [],
		catAreasOfInterest: [],
		catAmountOtherHouseHold: [],
		catRelationships: []
	}

};
export default {
	getGlobal,
	arrayCatalogs,
	getInitialDataPeople,
	getInitialDocument,
	getInitialDataPhone,
	getInitialDataHome
};
